import router from "@/router"
import { auth } from "@/services/auth"
import { isEntitled } from "@/services/entitlements"

/**
 * Would the router's own guards (`router/navigation-guard.js`) let the current user open `to`?
 *
 * Reads the target's `meta` instead of repeating its permissions, so an entry offered this way can
 * never lead somewhere the guard turns the user away from: `requiresPermissions` is "at least one
 * of", `requiresAllPermissions` is "all of", and `requiresFeatureSet` is the tenant's purchased
 * add-on (whose guard would answer with the upsell page).
 *
 * @param to anything `router.resolve` accepts, e.g. `{ name: "ProjectCreate" }`
 */
export function canReachRoute(to) {
  const { meta } = router.resolve(to)
  if (meta.requiresPermissions && !auth.hasOneOfPermissions(meta.requiresPermissions)) return false
  if (meta.requiresAllPermissions && !auth.hasAllOfPermissions(meta.requiresAllPermissions)) return false
  if (meta.requiresFeatureSet && !isEntitled(meta.requiresFeatureSet)) return false
  return true
}
